import type { FaireProductEntity } from "../../entity_types/product";

export const p_by9smzek87: FaireProductEntity = {
  token: "p_by9smzek87",
  type: "product",
  name: "Stainless Steel Tea Infuser Mesh Strainer for Loose Leaf Tea",
  brandToken: "b_bc7t8g6dg8",
  brandName: "Rich & Pour",
  imageUrl:
    "https://cdn.faire.com/fastly/b9a07225473a8b55586cddce79b3d903161cba63c46b09e518d29a3ce6d8cadf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12eda8923594089d48d092c210b2d2220209c5ef29da6a76c0d5263101d3f36e.jpeg",
    "https://cdn.faire.com/fastly/61d56ad6403cad4aad75d1a96ccc3b055a578cb74cccda27368a923e0088033f.jpeg",
    "https://cdn.faire.com/fastly/52047e4c6857c7068482b73776be4732aef8d8ad006aa77d348aaf9d1325802f.jpeg",
    "https://cdn.faire.com/fastly/9c571ac9a1342adaa8bafd1a12c106e43d8458d30e112b8b7c89900f6379923e.jpeg",
    "https://cdn.faire.com/fastly/6ecb62749c11a0b67aea35f3babde98b4d33d3100b10cf6cdf30b9f04b7ca5bc.jpeg",
    "https://cdn.faire.com/fastly/376b2afe8624e1bd445f2a1346dd0709c54b54f27afa625786487d069941920a.jpeg",
    "https://cdn.faire.com/fastly/9e5416d3d7381463f2fd19a72e8341b8757ac8cf5c3dab4636fa047d74db0e7d.jpeg",
    "https://cdn.faire.com/fastly/1efb275d09e147e374f9fc362364f7e0ed87c834871411963977c7523bc4f781.jpeg",
    "https://cdn.faire.com/fastly/3f522f2ebf26302089b4499e0c8342ba7d898b5c8efa44aeef4c01dae05b73e1.jpeg",
    "https://cdn.faire.com/fastly/6238e63c97028af5bc60aefa8329ecc1c3da3e4df5908ccac06e5099eb179fd6.jpeg",
  ],
  priceDollars: 8,
  description:
    "This large strainer allows looseleaf tea or coffee to circulate in the roomy basket for the optimal infusion - leading to richer flavor. This infuser features two handles that fit in most mugs, glasses, teapots or jugs. The extra fine holes allow only water to flow through. The stainless steel lid helps keep your tea hot during brewing and can double as a coaster for the infuser to rest on after brewing.\n\n𝐈𝐍𝐒𝐓𝐑𝐔𝐂𝐓𝐈𝐎𝐍𝐒:\n\n• Place infuser in mug or cup, resting handles on the brim.\n• Fill infuser with loose tea. Start with 1 teaspoon per 6oz, add more to taste.\n• Pour hot water over tea until the water line is near the top of the basket.\n• Steep for 4-7 min.",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:27:50.538Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
